<div id="content" class="allcp-form" ng-controller="CalendarController">
    <div ng-include="'modules/company/menus/order_menu.html'"></div>
    
    <header class="navbar navbar-fixed-top subnavbar bg-system" style="z-index: 999;">
        <ul class="nav navbar-nav navbar-left">
    
            <select class="ml10 selectpicker" 
                multiple 
                title="Personel"
                data-live-search="true" 
                data-selected-text-format="count" 
                data-language="tr_TR"
                ng-model="filterData.workers"
                data-style="btn-primary">
                <option ng-repeat="member in data.workers" data-select-watcher data-last="{{$last}}" value="{{member.id}}">{{member.full_name}}</option>
            </select>
    
            <ui-select ng-model="filterData.customers" title="Müşteri" class="ml10 operation-live-search" style="width:200px" multiple>
                <ui-select-match placeholder="Müşteri Seçiniz...">{{ $item.customer_name }}</ui-select-match>
                <ui-select-choices refresh="searchCustomer($select,'')" refresh-delay="0" repeat="searchRes in searchRes">
                    <span ng-bind-html="searchRes.customer_name | highlight: $select.search"></span>
                </ui-select-choices>
            </ui-select>
                
            <select class="ml10 selectpicker" 
                multiple 
                title="KargoDurumu"
                data-live-search="true" 
                data-selected-text-format="count" 
                data-language="tr_TR"
                ng-model="filterData.workSteps"
                data-style="btn-primary">
                <option ng-repeat="item in data.steps" data-select-watcher data-last="{{$last}}" value="{{item.id}}">{{item.name}}</option>
            </select>
    
            <select class="ml10 selectpicker" 
                multiple 
                title="KargoTürü"
                data-live-search="true" 
                data-selected-text-format="count" 
                data-language="tr_TR"
                ng-model="filterData.workTypes"
                data-style="btn-primary">
                <option ng-repeat="item in data.types" data-select-watcher data-last="{{$last}}" value="{{item.id}}">{{item.name}}</option>
            </select>
    
            <a href="#" class="btn btn-operation ml10" ng-click="clearFilter()" style="line-height: 20px;">
                <i class="fa fa-times"></i>
            </a>

            <a href="#" class="btn btn-operation ml10" ng-click="refreshData('calendar')" style="line-height: 20px;">
                <i class="fa fa-refresh"></i>
            </a>
    
        </ul>
        <ul class="nav navbar-nav navbar-right">
            <strong class="mr20">{{ calendarTitle }}</strong>
            <button
                style="line-height: 20px;" 
                class="btn btn-operation"
                mwl-date-modifier
                date="viewDate"
                decrement="calendarView"
                ng-click="changeDate()">
                Önceki 
            </button>
            <button
                style="line-height: 20px;" 
                class="btn btn-operation"
                mwl-date-modifier
                date="viewDate"
                set-to-today
                ng-click="changeDate()">
                Şimdi
            </button>
            <button
                style="line-height: 20px;" 
                class="btn btn-operation"
                mwl-date-modifier
                date="viewDate"
                increment="calendarView"
                ng-click="changeDate()">
                Sonraki 
            </button>
    
            <label 
                class="btn btn-operation" 
                style="line-height: 20px;" 
                ng-click="changeCalendarView('month')">Ay</label>
            <label 
                class="btn btn-operation" 
                style="line-height: 20px;" 
                ng-click="changeCalendarView('week')">Hafta</label>
            <label 
                class="btn btn-operation" 
                style="line-height: 20px;" 
                ng-click="changeCalendarView('day')">Gün</label>
    
            
        </ul>
    </header>
	<div class="row">
		<div class="panel p2">
			<div class="panel-body p20 ptn m20" style="min-height: 10; max-height: 10;">
                <mwl-calendar
                    events="events"
                    view="calendarView"
                    view-title="calendarTitle"
                    view-date="viewDate"
                    on-event-click="eventClicked(calendarEvent)"
                    on-event-times-changed="eventTimesChanged(calendarEvent); calendarEvent.startsAt = calendarNewEventStart; calendarEvent.endsAt = calendarNewEventEnd"
                    cell-is-open="cellIsOpen"
                    day-view-start="06:00"
                    day-view-end="22:59"
                    day-view-split="30"
                    cell-modifier="modifyCell(calendarCell)"
                    cell-auto-open-disabled="true"
                    on-timespan-click="timespanClicked(calendarDate, calendarCell)">
                </mwl-calendar>
			</div>
		</div>
	</div>
	<!-- Delete Orders -->
	<div class="modal right fade" id="deleteOrdersModal" tabindex="-1" role="dialog" aria-labelledby="deleteOrdersModalLabel">
	    <div class="modal-dialog" role="document">
	        <div class="modal-content">
	            <div class="modal-header">
	                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
	                <h4 class="modal-title" id="deleteOrdersModalLabel">Dikkat!</h4>
	            </div>
	            <div class="modal-body">
	                <div class="row">
	                    <div class="col-md-12">
	                        <p>Bu iş kalıcı olarak silinecektir. Bu işlem geri alınamaz!</p>
	                        <strong>Devam etmek istiyor musunuz ?</strong>
	                    </div>
	                </div>
	            </div>
	            <div class="modal-footer bg-light">
					<button type="button" class="btn btn-default" data-dismiss="modal">Vazgeç</button>
					<button type="button" class="btn btn-danger" ng-click="deleteOrders()">Sil</button>
	            </div>
	        </div>
	    </div>
	</div>
</div>